<template>
  <div
    class="h-1 bg-primary-light overflow-hidden rounded-full"
    role="progressbar"
    :aria-valuenow="value"
    :aria-valuemin="min"
    :aria-valuemax="max"
  >
    <div
      :style="style"
      class="h-full bg-primary-dark rounded-full transition-all duration-300"
      data-testid="progressbar-indicator"
    ></div>
  </div>
</template>
<script lang="ts">
import { defineComponent, computed } from 'vue'

export default defineComponent({
  props: {
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      required: true
    },
    value: {
      type: Number,
      required: true
    }
  },
  setup (props) {
    const style = computed(() => {
      const range = props.max - props.min
      const valueInRange = props.value - props.min

      return { width: `${(valueInRange * 100) / range}%` }
    })

    return { style }
  }
})
</script>
